import React from 'react';
import { withAppLayout } from '../core/routes';
import CustomersPage from './pages/CustomersPage';
import CustomerFormPage from './pages/CustomerFormPage';

export const customersRoutes = [
  { path: '/customers', element: withAppLayout(<CustomersPage />) },
  { path: '/customers/new', element: withAppLayout(<CustomerFormPage />) },
  { path: '/customers/:id/edit', element: withAppLayout(<CustomerFormPage />) },
];
